module.exports = __webpack_public_path__ + "static/media/wm_bg_move.1e37165a.jpg";